import React, { FC, ReactElement, useContext } from 'react'
import IconButton, { IconButtonType } from '../../Common/Components/IconButton'
import { IconName } from '../../Common/Components/Icon'
import CLanguageHandler from '../../../NonReact/Languages/LanguageHandler'
import { LanguageContext, PromptContext } from '../../Common/Contexts'
import { UsersByExtension } from '../../../../i18n'
import { PromptDisplayType } from '../../Common/Contexts/PromptContext'
import { CxIntegrationLicence } from '../../../NonReact/common/Types/SelfProvisioning/SelfProvisioningTypes'
import { LanguageUtils } from '../../Common/Utils/LanguageUtils'

type Props = {
    provisionAllUsers: () => Promise<void>
    cxIntegrationLicenseType: CxIntegrationLicence
}

export const ProvisionAllCxi: FC<Props> = ({ provisionAllUsers, cxIntegrationLicenseType }: Props): ReactElement => {
    const language: CLanguageHandler = useContext(LanguageContext) as CLanguageHandler
    const { displayPromptPromise }: PromptDisplayType = useContext(PromptContext)

    const licenceTypeLanguageValue: string = language.get(
        `UsersByExtension_CxiLicenceType_${cxIntegrationLicenseType.replace(' ', '_')}`
    )

    const clickHandler = (): void => {
        displayPromptPromise(
            LanguageUtils.formatLanguageEntry(
                language.getInterpolated(UsersByExtension.ProvisionAllCxi_PromptMessage, licenceTypeLanguageValue)
            ),
            language.get(UsersByExtension.AddAllUsers_Confirm),
            language.get(UsersByExtension.AddAllUsers_Cancel)
        ).then(provisionAllUsers)
    }

    return (
        <div className='add-all-extensions'>
            <div className='add-all-icon-container'>
                <IconButton
                    type={IconButtonType.BUTTON}
                    iconName={IconName.PROVISION_ALL_CXI}
                    onClick={(): void => clickHandler()}
                    title={language.getInterpolated(
                        UsersByExtension.ProvisionAllCxi_Button_Title_Interpolated,
                        licenceTypeLanguageValue
                    )}
                />
            </div>
        </div>
    )
}
